export default __webpack_public_path__ + "assets/footer-logo.e26f0ec6.png";